import { all, takeLatest, put, call, fork } from "redux-saga/effects";
import { apiV2 } from "../../services/api";
import { actions, constants } from "./actions";
import { commonConstants } from "../common/actions";

const { FETCH_RECOGNITIONS_LIST } = constants;
const { REQUEST } = commonConstants;

const { honorWall: honorWallApi } = apiV2;

const { fetchRecognitionsList } = actions;

function* fetchRecognitionsListRequest() {
  yield takeLatest("FETCH_RECOGNITIONS_LIST/REQUEST", function* () {
    const source = FETCH_RECOGNITIONS_LIST + REQUEST;
    try {
      const recognitions = yield call(honorWallApi.recognitions.getAll);
      yield put(
        fetchRecognitionsList.success({
          data: recognitions,
          source,
        })
      );
    } catch (error) {
      yield put(
        fetchRecognitionsList.failure({
          message: "Unable to load recognitions, please try again",
          source,
        })
      );
    }
  });
}

export default function* rootSaga() {
  yield all([fork(fetchRecognitionsListRequest)]);
}
